import React from 'react';
import PropTypes from 'prop-types';
import b from 'b_';
import FuseInfoTooltip from '../FuseControls/FuseTooltip/FuseInfoTooltip';
import Icon from '../Icon/Icon';
import './PfptLabelWithInfo.css';

const block = b.lock('PfptLabelWithInfo');

export default function PfptLabelWithInfo({ children, tooltip, tooltipText }) {
    return <div className={block()}>
        <Icon type="logo" className={block('Logo')}/>
        <div className={block('Name')}>{children}</div>
        {tooltip ? <div className={block('Tooltip')}>
            {tooltipText}
            <FuseInfoTooltip position="right" inline>{tooltip}</FuseInfoTooltip>
        </div> : null}
    </div>;
}

PfptLabelWithInfo.propTypes = {
    tooltip: PropTypes.node,
    tooltipText: PropTypes.node,
};
